const questions = (price) => {
  const questionsArray = [
    {
      question: "What is a UTI?",
      answer:
        "A urinary tract infection, or UTI, is an infection in any part of your urinary tract. UTIs commonly occur in women when bacteria enter the urinary tract (including the urethra and bladder). Typical symptoms include pain and burning when urinating, frequent urination, urgent urination, and cloudy-appearing urine.",
    },
    {
      question: "When should I see a doctor for a UTI?",
      answer:
        "You’ll want to see a provider as soon as you notice symptoms of a urinary tract infection (UTI). A common symptom is pain or burning when you urinate, but you might also feel a frequent urge to urinate even when your bladder is empty. If you start experiencing pain in your back or side, or if you develop a fever, this might be a sign of a more serious infection in your kidneys.While we always advise making an appointment + seeing a doc in person , we may be able to provide immediate Tx for simple UTIs saving you time + money.",
    },
    {
      question: "What causes a UTI?",
      answer:
        "Urinary tract infections (UTIs) happen when bacteria is able to get into the urinary tract, causing an infection. Different factors can increase the likelihood of this happening, like sexual activity, changes in hormone levels during menopause, pregnancy.",
    },
    {
      question: "Can a UTI go away on its own?",
      answer:
        "It is best to see a provider if you are experiencing symptoms of a urinary tract infection (UTI). Leaving it untreated may result in a more serious infection that spreads to your kidneys. UTIRX.com offers online visits for UTI so that you can get started on treatment sooner.",
    },
    {
      question: "What are the symptoms of a UTI?",
      answer:
        "A common symptom of a urinary tract infection (UTI) is a painful or burning sensation when you urinate. You might also feel a frequent urge to pee even when your bladder is empty or notice that your urine looks bloody or cloudy. Sometimes a UTI can spread to your kidneys, causing back or side pain, fever, chills, and nausea.",
    },
    {
      question: "What is the best thing to do for a UTI?",
      answer:
        "First, you’ll want to see a provider to get started on an antibiotic as soon as you start experiencing symptoms of a urinary tract infection (UTI). The sooner you start treatment, the sooner you’ll start to feel better. Make sure that you drink plenty of water or other fluids. Your provider may also prescribe the medication phenazopyridine to help with any pain or discomfort.",
    },
    {
      question: "What is the main cause of UTIs in females?",
      answer:
        "Women are more likely to get urinary tract infections (UTIs) because their anatomy (shorter urethra) makes it easier for bacteria to get into the urinary tract to cause an infection. Factors that can make this more likely to happen include sexual activity, changes in hormone levels during menopause, pregnancy, and certain forms of birth control.",
    },
    {
      question: "What does a UTI feel like?",
      answer:
        "A urinary tract infection (UTI) usually feels like a painful or a burning sensation when you urinate, and you may feel a frequent urge to pee even when you have an empty bladder. Sometimes the infection can reach your kidneys and cause back or side pain, fever, chills, and nausea.",
    },
    {
      question:
        "Can I get antibiotics for a urinary tract infection (UTI) without seeing a doctor?",
      answer:
        `Now you do not need to visit a provider’s office to be prescribed antibiotics for a simple urinary tract infection (UTI). Instead, you can be put in contact with a provider online from the comfort of your home, which can help you start treatment sooner.UTIRX.com offers online visits for UTI prescriptions for as low as $${price}.`,
    },
    {
      question: "Will a UTI go away without antibiotics?",
      answer:
        "Since a urinary tract infection (UTI) is an infection that is usually caused by bacteria, you’ll typically need an antibiotic to clear it. Leaving a UTI untreated can result in a more serious infection that spreads to your kidneys.",
    },
    {
      question: "How Can UTIRX.com Help with UTIs?",
      answer:
        "Most UTIs respond quickly to treatment with an appropriate antibiotic. UTIRX.com connect you with providers who can prescribe antibiotics. The exact treatment they prescribe depends on your diagnosis and history.Common Antibiotics Include:Macrobid (Nitrofurantoin)Keflex (Cephalexin)Bactrim (Sulfamethoxazole / Trimethoprim)",
    },
    {
      question: "Is This Service Right For Me?",
      answer:
        "Whether it’s your first UTI or you’ve had several (if so, we’re so sorry!), providers may be able to help.We’ll ask you a series of questions to see if this service is right for you. You will only proceed if we feel that this service will benefit you. If you are a good candidate.",
    },
  ];
  return questionsArray;
}

export default questions;
